import React, { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useUser } from '../../contexts/UserContext';
import DynamicBackground from '../../components/DynamicBackground';
import '../../styles/darkMode.css';
import './PaymentSuccess.css';

const PaymentSuccess: React.FC = () => {
  const navigate = useNavigate();
  const { user, refreshUser } = useUser();
  const [searchParams] = useSearchParams();
  const [loading, setLoading] = useState(true);
  const logo = process.env.PUBLIC_URL + '/SOUND_LEGAL_WHITE.png';

  useEffect(() => {
    const sessionId = searchParams.get('session_id');
    
    if (!sessionId) {
      navigate('/buy-credits');
      return;
    }

    // Refresh user data to get updated credits/subscription
    const refreshUserData = async () => {
      if (!user) {
        setLoading(false);
        return;
      }

      try {
        await refreshUser();
      } catch (error) {
        console.error('Error refreshing user data:', error);
      } finally {
        setLoading(false);
      }
    };

    // Wait a bit for webhook to process
    setTimeout(refreshUserData, 2000);
  }, [searchParams, user, refreshUser, navigate]);

  if (loading) {
    return (
      <DynamicBackground>
        <div className="payment-success-content">
          <img src={logo} alt="SoundLegal.ai Logo" className="success-logo" />
          <div className="loading-spinner">
            <div className="spinner"></div>
            <p>Processing your payment...</p>
          </div>
        </div>
      </DynamicBackground>
    );
  }

  return (
    <DynamicBackground>
      <div className="payment-success-content">
        <img src={logo} alt="SoundLegal.ai Logo" className="success-logo" />
        
        <div className="success-card">
          <div className="success-icon">✅</div>
          <h1 className="success-title">Payment Successful!</h1>
          
          {user?.subscriptionStatus === 'active' ? (
            <div className="success-message">
              <p>Your Enterprise subscription is now active!</p>
              <p>You now have unlimited access to all SoundLegal.ai features.</p>
            </div>
          ) : (
            <div className="success-message">
              <p>Your credits have been added to your account!</p>
              <p>You now have <strong>{user?.credits || 0}</strong> credits available.</p>
            </div>
          )}

          <div className="success-actions">
            <button 
              className="action-button primary"
              onClick={() => navigate('/tools')}
            >
              Start Using Tools
            </button>
            <button 
              className="action-button secondary"
              onClick={() => navigate('/')}
            >
              Back to Home
            </button>
          </div>
        </div>
      </div>
    </DynamicBackground>
  );
};

export default PaymentSuccess;

